import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import type { ProjectTemplateStatusAction } from "./projectTemplateStatusActions";
import { projectTemplateStatusActions } from "./projectTemplateStatusActions";
import type { ProjectTemplateStatusState } from "./projectTemplateStatusReducer";
export type ProjectTemplateStatus = {
    state: ProjectTemplateStatusState;
    dispatch: React.Dispatch<ProjectTemplateStatusAction>;
    refetch?: () => void;
};
const useProjectTemplateStatusFromServer = (dispatch: React.Dispatch<ProjectTemplateStatusAction>, slug?: string, gitRef?: string) => {
    const { result: projectTemplateStatusFromServer, refetch: refetchProjectTemplateStatusFromServer } = useInlineStatusQuery(async (repository) => {
        if (!slug || !gitRef) {
            return undefined;
        }
        const serverState = await repository.ProjectTemplates.getStatus(slug, gitRef);
        dispatch({
            type: projectTemplateStatusActions.projectTemplateServerStateLoaded,
            serverState,
        });
        return serverState;
    }, [slug, gitRef, dispatch], "Load project template status");
    return { projectTemplateStatusFromServer, refetchProjectTemplateStatusFromServer };
};
export function useProjectTemplateStatus(dispatch: React.Dispatch<ProjectTemplateStatusAction>, slug?: string, dismissed?: boolean, gitRef?: string): {
    refetch: () => void;
} {
    const { refetchProjectTemplateStatusFromServer } = useProjectTemplateStatusFromServer(dispatch, slug, gitRef);
    return { refetch: refetchProjectTemplateStatusFromServer };
}
